// extracted by mini-css-extract-plugin
module.exports = {"notificationBase":"CertificationNotification_notificationBase__yYc7x","large":"CertificationNotification_large__RthmG","small":"CertificationNotification_small__Xi8Ga"};